const template = document.createElement('template')
template.innerHTML = `
<style>

:host {
  position: relative;
  display: flex;
}

.wrap-list {
  display: flex;
  overflow: hidden;
  width: 100%;
}

.list::-webkit-scrollbar { /* hide scrollbar webkit */
  display: none;
}

.list {
  display: flex;
  gap: var(--vp-border-size);

  overflow: auto hidden;
  // touch-action: pan-x;
  user-select: none;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  /* prevent scroll chaining on x scroll */
  overscroll-behavior-x: contain;
  scrollbar-width: none; /* hide scrollbar firefox */
  width: 100%;
}

::slotted([slot="item"]) {
  scroll-snap-align: start;
  flex-shrink: 0;
}

.controls {
  position: absolute;
  top: 0;
  width: 100%;
}

</style>

<div class="wrap-list">
  <div class="list">
    <slot name="item"></slot>
  </div>
</div>
<slot name="controls"></slot>
`

customElements.define(
  'vp-slider',
  class extends HTMLDivElement {
    constructor() {
      super()

      this.connected = false

      this.attachShadow({ mode: 'open' })
      const clone = template.content.cloneNode(true)
      this.shadowRoot.appendChild(clone)
      this.scrolling = null
      this.dom = {}
      this.dom.list = this.shadowRoot.querySelector('.list')
      this.dom.controls = this.shadowRoot.querySelector('[name="controls"]')

      this.dom.controls.addEventListener('click', (e) => {
        const target = e.target.closest('.prev,.next')
        if (!target) return
        if (target.classList.contains('prev')) this.prev()
        if (target.classList.contains('next')) this.next()
      })
    }

    connectedCallback() {
      this.connected = true
      this.checkControls()
      this.goTo(this.first())
    }

    // get observedAttributes() {
    //   return ['controls', 'nav'];
    // }

    // get controls() {
    //   return this.hasAttribute('controls') && this.truthy(this.getAttribute('controls'));
    // }

    // set controls(value) {
    //   this.setAttribute('controls', (value ? 'true' : 'false'));
    // }

    // get nav() {
    //   return this.hasAttribute('nav') && this.truthy(this.attributes.nav);
    // }

    // attributeChangedCallback(name, oldValue, newValue) {
    //   if (this.connected) {
    //     // console.log(`L'attribut ${name} à changé de valeur de ${oldValue} à ${newValue}`);
    //     switch (name) {
    //       case 'gutter':
    //         const gutter = parseInt(newValue || 0, 10);
    //         this.shadowRoot.querySelector('.list').style.gap = `${parseInt(newValue || 0, 10)}px`;
    //         break;
    //       case 'controls':
    //         break;
    //     }
    //   }
    // }

    // return an array of all elements
    elements() {
      const slot = this.dom.list.querySelector(':scope > slot')
      return slot.assignedNodes()
    }

    // slide to previous element
    prev() {
      if (this.dom.list.scrollLeft <= 0) {
        // console.log('scroll min');
      } else {
        const elements = this.elements()
        const current = this.current()
        const element = elements[current - 1] || null
        // console.log('current ', current, ', goto ', current - 1, element)
        if (element && !this.scrolling) this.goTo(element)
      }
    }

    // slide to next element
    next() {
      if (
        this.dom.list.scrollLeft + this.dom.list.offsetWidth >=
        this.dom.list.scrollWidth
      ) {
        // console.log('scroll max');
      } else {
        const elements = this.elements()
        const current = this.current()
        const element = elements[current + 1] || null
        // console.log('current ', current, ', goto ', current + 1, element)
        if (element && !this.scrolling) this.goTo(element)
      }
    }

    // return first element
    first() {
      const elements = this.elements()
      return elements[0] || null
    }

    // return last element
    last() {
      const elements = this.elements()
      return elements[elements.length - 1] || null
    }

    // return current index
    current() {
      const elements = this.elements()
      let index = null
      const last = elements.length - 1
      for (let i = 0; i < elements.length; i += 1) {
        const el1 = elements[i]
        const el2 = elements[i + 1] || null
        const listLeft = Math.floor(this.dom.list.scrollLeft)
        const elLeft = Math.floor(el1.offsetLeft)
        // console.log(i, listLeft, elLeft)
        if (elLeft >= listLeft) {
          index = elLeft > listLeft && el2 && i + 1 < last ? i + 1 : i
          break
        }
      }
      return index
    }

    // slide to element
    goTo(element) {
      if (this.scrolling !== null) {
        clearTimeout(this.scrolling)
      }
      this.scrolling = setTimeout(() => {
        this.scrolling = null
      }, 600)
      this.dom.list.scrollTo({
        top: 0,
        left: element.offsetLeft,
        behavior: 'smooth',
      })
    }

    // check if controls is necessary, hide it if not
    checkControls() {
      if (
        this.dom.list.scrollLeft + this.dom.list.offsetWidth >=
        this.dom.list.scrollWidth - 10
      ) {
        this.dom.controls.style.display = 'none'
      }
    }

    // return true if value is a "truthy" one, false otherwise
    static truthy(value) {
      return (
        value === null ||
        ['', '1', 'true', 'yes', 'on'].includes(value.toLowerCase())
      )
    }
  },
  { extends: 'div' },
)
